import type { Line } from './flow';

// Where each printed line of a measured feedback paragraph ends, read from the
// browser's layout of its words. Words are counted the way splitRuns counts
// them, one per run of non-space characters in each text node.
export function paragraphLines(block: HTMLElement): Line[] {
  const paragraph = block.querySelector('[data-testid="feedback-paragraph"]');
  const range = document.createRange();
  if (!paragraph || typeof range.getBoundingClientRect !== 'function') return [];
  const top = block.getBoundingClientRect().top;
  const lines: (Line & { top: number })[] = [];
  let words = 0;
  const walker = document.createTreeWalker(paragraph, NodeFilter.SHOW_TEXT);
  for (let node = walker.nextNode(); node !== null; node = walker.nextNode()) {
    for (const match of (node.textContent ?? '').matchAll(/\S+/g)) {
      range.setStart(node, match.index);
      range.setEnd(node, match.index + match[0].length);
      const box = range.getBoundingClientRect();
      words += 1;
      const last = lines[lines.length - 1];
      if (last && box.top < last.top + box.height / 2) {
        last.words = words;
        last.bottom = Math.max(last.bottom, box.bottom - top);
      } else {
        lines.push({ words, bottom: box.bottom - top, top: box.top });
      }
    }
  }
  return lines.map(({ words: count, bottom }) => ({ words: count, bottom }));
}
